import React from 'react';
import { Routes, BrowserRouter as Router, Route } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import LandingPage from './Components/LandingPage/components/LandingPage'
import Programmes from './Components/Programmes/components/Programmes'
import ProgramDetail from './Components/Programmes/components/ProgramDetail'
import Commissions from './Components/Commissions/components/Commission'
import ZoneIntervention from './Components/ZoneIntervention/components/ZoneIntervention'
import VisionMission from './Components/VisionMission/components/VisionMission'
import Objectifs from './Components/Objectifs/components/Objectifs'
import Approches from './Components/Approches/components/Approches'
import Resultats from './Components/Resultats/components/Resultats'
import OrganeGestion from './Components/OrganeGestion/components/OrganeGestion'
import Partenaire from './Components/Partenaire/components/Partenaire'
import Rapports from './Components/Rapports/components/Rapports'
import RapportsDetails2020 from './Components/Rapports/components/RapportsAnnuel/Rapports_detail_2020'
import RapportsDetails2021 from './Components/Rapports/components/RapportsAnnuel/Rapports_detail_2021'
import RapportsDetails2022 from './Components/Rapports/components/RapportsAnnuel/Rapports_detail_2022'
import RapportsDetails2023 from './Components/Rapports/components/RapportsAnnuel/Rapports_detail_2023'
import RapportsDetails2024 from './Components/Rapports/components/RapportsAnnuel/Rapports_detail_2024'
import RapportsDetails2025 from './Components/Rapports/components/RapportsAnnuel/Rapports_detail_2025'
import OutilsTravail from './Components/OutilsTravail/components/OutilsTravail'
import Plans from './Components/Plans/components/Plans'
import Actualite from './Components/Actualite/components/Actualite'
import ActualiteDetails from './Components/Actualite/components/ActualiteDetails'
import Testimony from './Components/Testimony/components/Testimony'
import Contact from './Components/Contact/components/Contact'
import Terms from './Components/Terms/components/Terms'
import Privacy from './Components/Privacy/components/Privacy'
import Login from './Components/Admin/Login/components/Login'
import Dashboard from './Components/Admin/Dashboard/dashboard';
import ProtectedRoute from '../src/utils/ProtectedRoutes';

function App() {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/Programmes" element={<Programmes />} />
        <Route path="/programmes/:programType" element={<ProgramDetail />} />
        <Route path="/Commissions" element={<Commissions />} />
        <Route path="/ZoneIntervention" element={<ZoneIntervention />} />
        <Route path="/VisionMission" element={<VisionMission />} />
        <Route path="/Objectifs" element={<Objectifs />} />
        <Route path="/Approches" element={<Approches />} />
        <Route path="/Resultats" element={<Resultats />} />
        <Route path="/OrganeGestion" element={<OrganeGestion />} />
        <Route path="/Partenaire" element={<Partenaire />} />
        <Route path="/Rapports" element={<Rapports />} />
        <Route path="/Rapport_Detail_2020" element={<RapportsDetails2020 />} />
        <Route path="/Rapport_Detail_2021" element={<RapportsDetails2021 />} />
        <Route path="/Rapport_Detail_2022" element={<RapportsDetails2022 />} />
        <Route path="/Rapport_Detail_2023" element={<RapportsDetails2023 />} />
        <Route path="/Rapport_Detail_2024" element={<RapportsDetails2024 />} />
        <Route path="/Rapport_Detail_2025" element={<RapportsDetails2025 />} />
        <Route path="/OutilsTravail" element={<OutilsTravail />} />
        <Route path="/Plans" element={<Plans />} />
        <Route path="/Actualite" element={<Actualite />} />
        <Route path="/Actualite/:slug" element={<ActualiteDetails />} />
        <Route path="/Testimony" element={<Testimony />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/Login" element={<Login />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/admin-dashboard/*" element={<Dashboard />} />
        </Route>

      </Routes>
    </Router>
  );
}

export default App;
